export default "__VITE_ASSET__5YZd9zs7__"